module.exports = __webpack_public_path__ + "assets/img/map1.6273103e.png";